<template>
  <div id="app" style="position: relative">
    <div style="position: absolute; top: 0; opacity: 0">
      <img src="/static/img/achuanqi.png" alt />
    </div>
    <router-view />
    <app-footer v-if="isShowFooter"></app-footer>
  </div>
</template>
<script>
import AppFooter from "./components/footer/index.vue";
import { getGameLink, getQQKey, getDownUrl } from "@/req/homes";
import { noFooterList } from "./config";
export default {
  data() {
    return {
      isShowFooter: false,
      path: "",
      paths: "",
      Height: 0,
      modelShow: false,
    };
  },
  created() {
    if (noFooterList.includes(window.location.pathname)) {
      this.isShowFooter = false;
    } else {
      this.isShowFooter = true;
    }
    if (this.isMobile()) {
      if (!noFooterList.includes(window.location.pathname)) {
        const channelCode = this.getUrlKey("id");
        if (channelCode && !this.checknumber(channelCode)) {
          location.href =
            "https://m.996box.com/channelPackage.html" +
            "?" +
            location.href.split("?")[1];
        } else {
          location.href = "http://m.996box.com/";
        }
      }
    } else {
      this.modelShow = true;
    }
    this.getDownList();
    this.getQQKeys();
  },
  mounted() {
    this.isIE();
    //    http://www.996box.com/&wd=&eqid=8d000c34000a4fc1000000066578510c
    // 判读url上是否有以上参数
    const notUrl = window.location.href.indexOf("&wd=");
    if (notUrl > 0) {
      window.location.href = window.location.origin;
    }
  },
  components: {
    AppFooter,
  },
  methods: {
    isIE() {
      if (!!window.ActiveXObject || "ActiveXObject" in window) {
        window.location.href = "http://land.996box.com/downloadPage/ie.html";
        return true;
      } else {
        return false;
      }
    },
    isMobile() {
      const flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    async getDownList() {
      const res = await getGameLink();
      this.$store.state.home.downList = res;
    },
    async getQQKeys() {
      const res = await getQQKey();
      if (res.code == 200) {
        this.$store.state.home.downImgList = res.data;
      }
    },
    getUrlKey(name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
    checknumber(channelCode) {
      const reg = /^[0-9]+.?[0-9]*$/;
      if (reg.test(channelCode)) {
        return true;
      }
      return false;
    },
  },
  watch: {
    $route(to, from) {
      this.path = to.path;
    },
  },
};
</script>

<style lang="less">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-family: "Microsoft YaHei";
  overflow-y: hidden;
}
#cnzz_stat_icon_1279745428,
#cnzz_stat_icon_1281148325,
#cnzz_stat_icon_1281149380,
#cnzz_stat_icon_1281235613,
#cnzz_stat_icon_1281273917,
#cnzz_stat_icon_1281273918,
#cnzz_stat_icon_1281277260 {
  opacity: 0;
  position: absolute;
}
::-webkit-scrollbar {
  display: none;
}
</style>
